import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { InternalCandidacyComment } from "@/types";

/**
 * This hook is used to add a new internal candidacy comment to the internal
 * candidacy comments query without refetching the entire query.
 */
export const useSetNewInternalCandidacyCommentInInternalCandidacyComments =
  () => {
    const currentCompanyId = useCurrentCompanyId();
    const currentJobId = useCurrentJobId();
    const queryClient = useQueryClient();

    return ({
      candidacyId,
      internalCandidacyCommentToAdd,
    }: {
      candidacyId: string;
      internalCandidacyCommentToAdd: InternalCandidacyComment;
    }) => {
      queryClient.setQueryData(
        [
          "internal-candidacy-comments",
          currentCompanyId,
          currentJobId,
          candidacyId,
        ],
        (cachedData: InternalCandidacyComment[] | undefined) => {
          // Important to add the new comment to the top of the list.
          return [internalCandidacyCommentToAdd, ...(cachedData ?? [])];
        },
      );
    };
  };
